<template>
  <b-row>
    <b-col
      cols="12"
      md="8"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">
              <!-- Banner -->
              <b-form-group
                label="Banner"
                label-for="v-banner"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Banner"
                  rules=""
                >
                  <form-image
                    v-model="form.image"
                    label="Pilih Banner"
                    :state="errors.length > 0 ? false : null"
                    width-full
                    with-endpoin
                    aspect-ratio="2/1"
                    :accept-type="['image']"
                    @finish="onInputImage"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Judul -->
              <b-form-group
                label="Judul"
                label-for="v-name"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Judul"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Kode -->
              <b-form-group
                label="Kode"
                label-for="v-code"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kode"
                  :rules="form.is_claimable ? '' : 'required'"
                >
                  <b-form-input
                    id="v-code"
                    v-model="form.code"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Jenis Voucher (admin only) -->
              <b-form-group
                v-if="$store.state.auth.userData.role === 'admin'"
                label="Jenis Voucher"
                label-for="v-type"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jenis voucher"
                  rules="required"
                >
                  <b-form-select
                    id="v-type"
                    v-model="form.type"
                    :options="typeOptions"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Deskripsi -->
              <b-form-group
                label="Deskripsi"
                label-for="v-description"
                label-cols-md="4"
              >
                <quill-editor
                  id="v-description"
                  v-model="form.description"
                  class="medium-height"
                />
              </b-form-group>

              <hr>

              <!-- Kategori -->
              <b-form-group
                label="Kategori"
                label-for="v-category"
                label-cols-md="4"
              >
                <v-select
                  v-model="selectedCategory"
                  label="name"
                  :options="categoryOptions"
                  :clearable="false"
                >
                  <template #no-options="">
                    Kategori tidak ditemukan.
                  </template>
                </v-select>
              </b-form-group>

              <!-- Brand -->
              <b-form-group
                v-if="$store.state.auth.userData.role === 'admin'"
                label="Brand"
                label-for="v-brand"
                label-cols-md="4"
              >
                <v-select
                  v-model="selectedBrand"
                  label="name"
                  :options="merchants.data"
                  placeholder="Semua Brand"
                  :filterable="false"
                  @search="searchBrand"
                >
                  <template #no-options="{searching}">
                    <span v-if="searching">Brand tidak ditemukan</span>
                    <span v-else>Ketik nama brand</span>
                  </template>
                </v-select>
              </b-form-group>

              <hr>

              <!-- Diskon -->
              <b-form-group
                v-if="form.type !== 'shipping'"
                label="Diskon"
                label-for="v-discount"
                label-cols-md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    lg="6"
                    xl="6"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Diskon"
                      rules="required|min_value:1|max_value:100"
                    >
                      <b-input-group append="%">
                        <b-form-input
                          id="v-discount"
                          v-model="form.discount"
                          type="number"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- Potongan Maksimum -->
              <b-form-group
                label="Potongan Maksimum"
                label-for="v-max-discount"
                label-cols-md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    lg="6"
                    xl="6"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Potongan maksimum"
                      rules="required"
                    >
                      <b-input-group prepend="Rp">
                        <cleave
                          id="v-max-discount"
                          v-model="form.max_discount"
                          class="form-control"
                          :class="{'is-invalid' : errors.length > 0}"
                          :raw="true"
                          :options="options.number"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- Minimum Transaksi -->
              <b-form-group
                label="Minimum Transaksi"
                label-for="v-minimum-transaction"
                label-cols-md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    lg="6"
                    xl="6"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Minimum transaksi"
                      rules="required"
                    >
                      <b-input-group prepend="Rp">
                        <cleave
                          id="v-minimum-transaction"
                          v-model="form.minimum_transaction"
                          class="form-control"
                          :class="{'is-invalid' : errors.length > 0}"
                          :raw="true"
                          :options="options.number"
                        />
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- Maksimum Penggunaan per Customer -->
              <b-form-group
                label="Maksimum penggunaan per Customer"
                label-for="v-maximum-order"
                label-cols-md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    lg="6"
                    xl="6"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Maksimum penggunaan per customer"
                      rules="required|min_value:1"
                    >
                      <cleave
                        id="v-maximum-order"
                        v-model="form.maximum_order"
                        class="form-control"
                        :class="{'is-invalid' : errors.length > 0}"
                        :raw="true"
                        :options="options.number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- Maksimum penggunaan Keseluruhan -->
              <b-form-group
                label="Maksimum penggunaan Keseluruhan"
                label-for="v-max-usage"
                label-cols-md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    lg="6"
                    xl="6"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Maksimum penggunaan keseluruhan"
                      rules="required|min_value:1"
                    >
                      <cleave
                        id="v-max-usage"
                        v-model="form.max_usage_all"
                        class="form-control"
                        :class="{'is-invalid' : errors.length > 0}"
                        :raw="true"
                        :options="options.number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- Syarat -->
              <b-form-group
                v-if="$can('manage', 'DashboardBrand')"
                label="Syarat lainnya"
                label-for="v-is-other-requirement"
                label-cols-md="4"
              >
                <div class="d-flex pt-50">
                  <b-form-checkbox
                    v-model="form.for_recurring_registry_owner"
                  >
                    Pemilik Registry Aktif

                    <feather-icon
                      class="ml-25 text-muted"
                      size="18"
                      v-b-tooltip.hover.top="'Usia registry ≥ 2 bulan, memiliki ≥ 10 produk, ≥ 5 terjual, dan usia anak ≤ 3 bulan'"
                      icon="InfoIcon"
                    />
                  </b-form-checkbox>
                </div>
                <div class="d-flex pt-50 mt-1">
                  <b-form-checkbox
                    v-model="form.exclude_mos"
                  >
                    Selain Miniapoly Official Store

                    <feather-icon
                      class="ml-25 text-muted"
                      size="18"
                      v-b-tooltip.hover.top="'Voucher dapat digunakan di semua merchant kecuali Miniapoly Official Store.'"
                      icon="InfoIcon"
                    />
                  </b-form-checkbox>
                </div>
              </b-form-group>

              <hr>

              <!-- Usage Bar -->
              <b-form-group
                label="Bar Penggunaan"
                label-for="v-is-usage-visible"
                label-cols-md="4"
              >
                <div class="d-flex">
                  <b-form-radio
                    v-model="form.is_usage_visible"
                    name="is-usage-visible"
                    :value="true"
                  >
                    Tampilkan
                  </b-form-radio>
                  <b-form-radio
                    v-model="form.is_usage_visible"
                    name="is-usage-visible"
                    :value="false"
                    class="ml-2"
                  >
                    Sembunyikan
                  </b-form-radio>
                </div>
              </b-form-group>

              <!-- Visibilitas -->
              <b-form-group
                label="Visibilitas"
                label-for="v-is-private"
                label-cols-md="4"
              >
                <div class="d-flex">
                  <b-form-radio
                    v-model="form.is_private"
                    name="some-radios"
                    :value="false"
                  >
                    Public
                  </b-form-radio>
                  <b-form-radio
                    v-model="form.is_private"
                    name="some-radios"
                    :value="true"
                    class="ml-2"
                  >
                    Private
                  </b-form-radio>
                </div>
              </b-form-group>

              <!-- Status -->
              <b-form-group
                label="Status"
                label-for="v-is-active"
                label-cols-md="4"
              >
                <div class="d-flex">
                  <b-form-radio
                    v-model="form.is_active"
                    name="is-active"
                    :value="true"
                  >
                    Tersedia
                  </b-form-radio>
                  <b-form-radio
                    v-model="form.is_active"
                    name="is-active"
                    :value="false"
                    class="ml-2"
                  >
                    Tidak Tersedia
                  </b-form-radio>
                </div>
              </b-form-group>

              <!-- Claimable -->
              <b-form-group label-cols-md="4">
                <b-form-checkbox
                  v-model="form.is_claimable"
                >
                  Claimable
                </b-form-checkbox>
              </b-form-group>

              <!-- Point Required -->
              <div v-if="form.is_claimable">
                <hr>
                <b-form-group
                  label="Poin diperlukan"
                  label-for="v-point_required"
                  label-cols-md="4"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      lg="6"
                      xl="6"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Poin"
                        rules="min_value:1"
                      >
                        <b-input-group append="Poin">
                          <b-form-input
                            id="v-point_required"
                            v-model="form.point_required"
                            placeholder="Opsional"
                            type="number"
                            :state="errors.length > 0 ? false : null"
                          />
                        </b-input-group>
                        <div>
                          <small>Point yang diperlukan untuk claim.</small>
                        </div>
                        <div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </div>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
              </div>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmit"
                >
                  <b-spinner
                    v-if="isSubmit"
                    small
                  />
                  {{ isSubmit ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormSelect,
  BFormRadio,
  BSpinner,
  BInputGroup,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, minValue, maxValue } from '@validations'
import FormImage from '@/layouts/components/custom/FormImage.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormSelect,
    BFormRadio,
    BInputGroup,
    BOverlay,
    BSpinner,
    BFormCheckbox,
    Cleave,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    FormImage,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeOptions: [
        { value: 'regular', text: 'Potongan Harga' },
        { value: 'shipping', text: 'Ongkir' },
      ],
      form: {
        name: '',
        code: '',
        type: 'regular',
        discount: null,
        max_discount: null,
        minimum_transaction: null,
        maximum_order: null,
        minimum_registry: null,
        max_usage_all: null,
        is_private: true,
        for_recurring_registry_owner: false,
        exclude_mos: false,
        is_active: true,
        category_id: null,
        merchant_id: null,
        description: '',
        is_claimable: false,
        is_usage_visible: true,
        point_required: null,
        image: null,
        media: null,
      },
      categoryOptions: [],
      selectedCategory: {
        id: null,
        name: 'Semua Kategori',
      },
      selectedBrand: null,
      required,
      minValue,
      maxValue,
      isPending: false,
      isSubmit: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralPositiveOnly: true,
        },
      },
    }
  },
  computed: {
    ...mapGetters('category', ['categoryList']),
    ...mapState('merchant', ['merchants']),
    ...mapState('voucher', ['voucher']),
    voucherId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true
    try {
      if (this.isEdit) {
        await this.getVoucherDetail({ voucherId: this.voucherId })
        this.fillData()
      }
      await this.getCategoryList({ isRoot: true })
      this.categoryOptions = this.categoryList
      this.categoryOptions.unshift({
        id: null,
        name: 'Semua Kategori',
      })
    } catch (error) {
      this.$swal({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        timer: 3000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
    this.isPending = false
  },
  methods: {
    ...mapActions('category', ['getCategoryList']),
    ...mapActions('merchant', ['getMerchantList']),
    ...mapActions('voucher', [
      'createVoucher',
      'editVoucher',
      'getVoucherDetail',
    ]),
    validationForm() {
      if (this.form.type === 'shipping') {
        this.form.discount = 100
      }
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmit = true
      try {
        if (this.selectedCategory) {
          this.form.category_id = this.selectedCategory.id
        }
        if (this.selectedBrand) {
          this.form.merchant_id = this.selectedBrand.id
        }

        if (!this.isEdit) {
          await this.createVoucher(this.form)
        } else {
          await this.editVoucher({ voucherId: this.voucherId, data: this.form })
        }
        this.$swal({
          title: 'Berhasil!',
          text: `Berhasil ${this.isEdit ? 'memperbaharui' : 'menambahkan'} voucher`,
          icon: 'success',
          timer: 3000,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        this.$router.push('/vouchers')
      } catch (error) {
        this.$swal({
          title: 'Error!',
          text: error.message,
          icon: 'error',
          timer: 3000,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
      this.isSubmit = false
    },
    async searchBrand(keyword, loading) {
      if (keyword.trim().length > 0) {
        loading(true)
        await this.getMerchantList({ keyword: keyword.trim() })
        loading(false)
      }
    },
    async onInputImage(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      this.form.media = datas.id
    },
    // Edit State Only
    fillData() {
      this.form.name = this.voucher.name
      this.form.code = this.voucher.code
      this.form.type = this.voucher.type
      this.form.discount = this.voucher.discount
      this.form.max_discount = this.voucher.max_discount
      this.form.minimum_transaction = this.voucher.minimum_transaction
      this.form.maximum_order = this.voucher.maximum_order
      this.form.minimum_registry = this.voucher.minimum_registry
      this.form.max_usage_all = this.voucher.max_usage_all
      this.form.is_private = this.voucher.is_private === 1
      this.form.for_recurring_registry_owner = this.voucher.for_recurring_registry_owner === 1
      this.form.exclude_mos = this.voucher.exclude_mos === 1
      this.form.is_active = this.voucher.is_active === 1
      this.form.description = this.voucher.description
      this.form.is_claimable = this.voucher.is_claimable === 1

      this.form.is_usage_visible = this.voucher.is_usage_visible === 1
      this.form.point_required = this.voucher.point_required
      this.form.image = this.voucher.poster

      if (this.voucher.category) {
        let name = ''
        if (this.voucher.category.parent_id) {
          // is children category
          name = `${this.voucher.category.parent} / ${this.voucher.category.name}`
        } else {
          name = this.voucher.category.name
        }
        this.selectedCategory = { id: this.voucher.category.id, name }
      }

      if (this.voucher.merchant) {
        this.selectedBrand = this.voucher.merchant
      }
    },
  },
}
</script>
